import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is IoT development?",
    answer: `<p>IoT development is developing IoT applications and products that can be controlled remotely and used to monitor the connected product's condition or environment via sensors and external data sources. Custom IoT Development is done to meet the specific requirements of a business.</p>`,
  },
  {
    question: "What is IoT application development?",
    answer: `<p>IoT app development involves creating a system where digital devices interact with each other through data exchanges, eliminating the need for human intervention. It focuses on developing IoT solutions that enable Machine-to-Machine (M2M) communication.</p>`,
  },
  {
    question: "What are IoT development services?",
    answer: `<p>Internet of Things (IoT) services encompass a comprehensive range of offerings where businesses collaborate with external providers to design, develop, implement, and manage IoT solutions. These services also include advisory consulting for IoT strategy and planning.</p>`,
  },
  {
    question: "How long does it take to implement IoT?",
    answer: `<p>Almost 18-24 months</p><p>Implementing IoT is challenging because of the complexity of its components. Studies show that the average time-to-market for an IoT project is approximately 18-24 months, with a failure rate of 75% for IoT initiatives.</p>`,
  },
  {
    question: "How much does it cost to build an IoT app?",
    answer: `<p>Building an Internet of Things (IoT) app generally costs around $37,500. However, the price can range from $25,000 to $50,000. An IoT app with fewer features also referred to as a minimum viable product (MVP), will be less expensive compared to a fully-featured application.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#FFF" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>IOT Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
